<template>
  <div
    v-if="caseInfo && data.type.key === 'card'"
    class="widget-case-card-wrapper card"
  >
    <senior-case-item :item="caseInfo" type="custom">
      <div class="card-footer">
        <h3 class="title font-color-body">{{ caseInfo.activity_name }}</h3>
        <span class="detail-btn">查看案例</span>
      </div>
    </senior-case-item>
  </div>
  <div
    v-else-if="caseInfo && data.type.key === 'file'"
    class="widget-case-card-wrapper file"
  >
    <senior-file-viewer
      v-if="caseInfo"
      :senior-info="caseInfo"
    ></senior-file-viewer>
    <div class="footer">
      <h1 class="title">
        <span v-if="caseInfo.isaward - 0 === 1" class="award-label">获奖</span>
        {{ caseInfo.activity_name }}
      </h1>
    </div>
  </div>
</template>

<script>
import { asyncImport } from '@/utils'
import SeniorCaseItem from '@/components/senior/SeniorCaseItem'
import { THIRD_API } from '@/global/config'

const { asyncComponent } = asyncImport

export default {
  components: {
    SeniorFileViewer: asyncComponent('senior/SeniorFileViewer'),
    SeniorCaseItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      caseInfo: null,
      favoriteDisabled: false,
      praiseDisabled: false
    }
  },
  created() {
    this.getSeniorInfo()
  },
  methods: {
    async getSeniorInfo() {
      const {
        source: { id = '', alias }
      } = this.data
      if (!id) {
        return
      }
      const res = await this.$http.get(THIRD_API.alkSeniorDetail.link, {
        params: { id }
      })
      const { data } = res
      if (
        data &&
        Object.prototype.toString.call(data) === '[object Object]' &&
        data.id === id
      ) {
        // 暂时在这个地方针对文件-视频文件特殊处理
        // 普通文件，用其自身，或列表第一张图
        // 视频文件，如果排在第一位，需要用第一张banner图，非第一位，用默认占位图
        const file = data.files
        if (
          file &&
          Object.prototype.toString.call(file) === '[object Array]' &&
          file.length
        ) {
          const banner = data.banner ? data.banner : data.thumbnail
          data.file = file.map((value, index) => {
            if (value.postfix === 'mp4') {
              value.banner = banner
            }
            value.fileId = value.id || index
            value.singleDownloadable = true
            return value
          })
        }
        // 别名处理
        if (alias) {
          data.activity_name = alias
        }
        // 奖项
        // 精品案例列表的award字段true-false
        // 精品案例详情的award字段[]
        data.awards = data.awards && data.awards.length
        data.articles = []
        this.caseInfo = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-case-card-wrapper {
  margin: 16px auto;
  &.file {
    background-color: #2c2c31;
    color: #ffffff;
    .footer {
      height: 96px;
      line-height: 96px;
      overflow: hidden;
      position: relative;
      padding: 0 260px 0 24px;
      .title {
        font-size: 32px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .award-label {
        display: inline-block;
        font-size: 14px;
        vertical-align: middle;
        height: 22px;
        padding: 0 10px;
        background-color: #bb9d7d;
        border-radius: 3px;
        line-height: normal;
        margin-right: 8px;
      }
      .actions {
        position: absolute;
        top: 0;
        right: 0;
        width: 260px;
        text-align: right;
        padding-right: 20px;
        button {
          background-color: rgba(255, 255, 255, 0.1);
          border: none;
          outline: none;
          color: #ffffff;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          padding: 0 16px;
          border-radius: 16px;
          margin-right: 20px;
          cursor: pointer;
          &:hover {
            background-color: rgba(51, 82, 254, 0.65);
          }
          &.on {
            background-color: #3352fe;
          }
        }
      }
    }
  }
  &.card {
    width: 550px;
    .card-footer {
      background-color: #f4f5f7;
      border: 1px solid #efeff4;
      border-top: none;
      height: 72px;
      line-height: 72px;
      padding: 0 144px 0 16px;
      position: relative;
      .title {
        font-size: 20px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .detail-btn {
        position: absolute;
        top: 18px;
        right: 32px;
        height: 32px;
        line-height: 32px;
        background-color: #ffffff;
        font-size: 14px;
        color: #3352fe;
        padding: 0 20px;
        border-radius: 3px;
        font-weight: bold;
      }
    }
  }
}
</style>

<style lang="scss">
.widget-case-card-wrapper {
  .senior-file-viewer-wrapper {
    .file-viewer-wrapper {
      height: 362px;
    }
  }
  .file-viewer-wrapper {
    &.normal {
      .list-container {
        .list-wrapper {
          width: 260px;
          padding-right: 20px;
        }
        .list-content {
          padding-left: 16px;
        }
        .list-toggle {
          display: none;
        }
      }
    }
  }
}
</style>
